import CabinetIcon from '../assets/cabinet';
import EncodingStationIcon from '../assets/encodingstation';
import ReaderIcon from '../assets/reader';
/*
import HammerIcon from '../assets/hammer';
import MiddlewareIcon from '../assets/logisticspc';

import EdgeServerIcon from '../assets/edgeServer';
import ForkliftIcon from '../assets/forklift';
//import ShelfIcon from '../assets/smartshelf';
*/

export const getIcon = type => types[type]['icon'];

// Key order is here same as displayed to user
export const types = {
  smartCabinet: {
    icon: CabinetIcon,
    subTypes: [
      'IF2',
      'IF3',
      'IF3Freezer',
      'IFG_3_0_S1_V1_EU',
      'IFG_3_0_R1S1_V1_EU',
    ],
  },
  encodingStation: {
    icon: EncodingStationIcon,
    subTypes: [],
  },
  selflyEncode: {
    icon: ReaderIcon,
    subTypes: [],
  },
  /*
  Hammer: {
    icon: HammerIcon,
    subTypes: [],
  },
  HandheldReader: {
    icon: ReaderIcon,
    subTypes: [],
  },
  
  IntelligentInventory: {
    icon: ReaderIcon,
    subTypes: ['Industrial', 'NewRetail'],
  },
  IVMICabinet: {
    icon: MiddlewareIcon,
    subTypes: [],
  },
  
  Forklift: {
    icon: ForkliftIcon,
    subTypes: [
      'RP',
      'Terminal',
      'TerminalRP',
    ],
  },
  ReadingPoint: {
    icon: ReaderIcon,
    subTypes: ['Gate', 'GateWithDS', 'GateWithEncode'],
  },
  EdgeServer: {
    icon: EdgeServerIcon,
    subTypes: [],
  },
  */
};

const OPTIONAL_SETTINGS = {
  SHELF_COUNT: ['IF2'],
  CARD_PAYMENT: types.smartCabinet.subTypes,
  SHELF_CONFIG: types.smartCabinet.subTypes.filter(
    st => !['IF2', 'IF3', 'IF3Freezer'].includes(st)
  ), // for scale or hybrid cabinets (scale + rfid)
};

export function hasOptionalSetting(subType, setting) {
  return OPTIONAL_SETTINGS[setting].includes(subType);
}
